import type { TPassportFormFields } from 'src/client/entities/creditForm';

export const isResidenceSameAsRegistration = (data: TPassportFormFields): boolean => {
  const isSameFlat = data.registrationAddressFlat === data.residenceAddressFlat;
  const isSameAddress =
    !!data.registrationAddress?.value && data.registrationAddress?.value === data.residenceAddress?.value;

  return isSameFlat && isSameAddress;
};
